module.exports = __webpack_public_path__ + "img/form@2x.f196587.webp";